import {Button} from "./Button";
import React from "react";
import './ClickHereImageButton.css'
import {Route, Routes} from "react-router-dom";
import Home from "./pages/Home";

export const ClickHereImageButton = ({title, linkPath, imagePath, component}) => {
    return (
        <div className='image-button' style={{background: `url(${imagePath}) center center/cover no-repeat`}}>
            <div className='image-button-content'>
                <h3>{title}</h3>
                <Routes>
                    <Route path={linkPath} element={component}/>
                </Routes>

                <Button className='btns' buttonLink={linkPath} buttonStyle='btn--outline'
                        buttonSize='btn--medium'>CLICK HERE</Button>
            </div>
        </div>
    )
}